// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3aRKa","title":"InfoRow_title__1o8QO"};